<template>
  <div>
    <v-container
        v-if="isLoading">
      <Loading/>
    </v-container>
    <v-container
      v-else
      flu
      id>
      <v-row
        no-gutters
        justify=end>
        <v-col
          cols=auto>
        <v-tooltip
          top>
          <template
            v-slot:activator="{ on }">
            <v-btn
              v-if="!fromParent"
              rounded
              outlined
              color="primary"
              class="main--text"
              @click="fromParent = true">
              あなたの依頼状況
            </v-btn>
          </template>
        </v-tooltip>
        <v-tooltip>
          <template
            v-slot:activator="{ on }">
            <v-btn
              v-if="fromParent"
              rounded
              outlined
              color="primary"
              class="main--text"
              @click="fromParent = false">
              応募一覧へ
            </v-btn>
          </template>
        </v-tooltip>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      v-if="!isLoading"
      fluid>
      <v-offers-from-parent
        v-if="fromParent"/>
      <v-row
        v-else-if="!fromParent && offers.length() === 0"
        no-gutters
        justify=center>
        <v-col
          md=10
          sm=10
          cols=12>
          <v-card>
            <v-container>
              <v-row>
                <v-col
                  class="main--text">
                  現在応募はありません。
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        v-else
        no-gutters
        justify=center>
          <v-col
            v-for="(student, index) in students.get()"
            :key="index"
            md=8
            sm=10
            cols=12>
            <v-offers-for-each-student
              :student="student"
              :offers="offers.filterByStudentId(student.id)"
              @agree-event="agreeWithOffer($event, student)"
              @disagree-event="disagreeWithOffer($event, student)"
              />
          </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { firestore } from "@/repository/client/firestore"
import { LessonOfferRepository } from "@/repository/LessonOfferRepository"
import { StudentRepository } from "@/repository/StudentRepository"
import { ParentRepository } from "@/repository/ParentRepository"
import { AgreeOfferService } from '@/service/lesson/agree-offer.js'
import VOffersForEachStudent from "@/components/organisms/parent/VOffersForEachStudent.vue"
import VOffersFromParent from "@/components/organisms/parent/VOffersFromParent.vue"
import Loading from "@/components/organisms/Loading.vue"

export default {
  components: {
    VOffersForEachStudent,
    VOffersFromParent,
    Loading
  },
  data () {
    return {
      isLoading: true,
      lessonRepo: null,
      offers: null,
      students: this.$store.getters.parent.students,
      parent: this.$store.getters.parent,
      fromParent: false
    }
  },
  methods: {
    async agreeWithOffer(offer, student) {
      const service = new AgreeOfferService(firestore, this.parent)
      this.parent = await service.execute(offer.id)
      // const updatedStudent = await this.studentRepo.update(student.registerLesson(offer.lesson))
      // const parent = await this.parentRepo.update(this.$store.getters.parent.updateStudent(updatedStudent))
      // const result = await this.lessonRepo.agree(offer)
      this.offers.remove(offer.id)
      this.$store.commit('loginAsParent', this.parent)
    },
    async disagreeWithOffer(offer, student) {
      const result = await this.lessonRepo.disagree(offer)
      this.offers.remove(offer.id)
    }
  },
  created: async function () {
    this.studentRepo = new StudentRepository(firestore)
    this.parentRepo = new ParentRepository(firestore)
    this.lessonRepo = new LessonOfferRepository(firestore)
    this.offers = await this.lessonRepo.listOfInOffer(this.$store.getters.parent.uuid)
    this.isLoading = false
  }
}
</script>
